(function() {
	'use strict';

	ExpiredStorage.prototype.hasValidKey = function(key)
	{
		return (!this.isExpired(key) && this.getItem(key) && this.getItem(key) !== undefined);
	};

	ExpiredStorage.prototype.rememberJson = function(key, expiration, callback)
	{
		if (!this.hasValidKey(key))
		{
			this.setJson(key, callback(), expiration);
		}
		return this.getJson(key);
	};

	ExpiredStorage.prototype.remember = function(key, expiration, callback)
	{
		if (!this.hasValidKey(key))
		{
			this.setItem(key, callback(), expiration);
		}
		return this.getItem(key);
	};
})();
